'use client';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// components/skeleton/react/src/version.ts
var name = "@gs-ux-uitoolkit-react/skeleton";
var version = "18.12.1                 ".trim();
var Version = { name, version };

// components/skeleton/react/src/analytics-tracking.ts
import { ComponentAnalytics } from "@gs-ux-uitoolkit-react/analytics";
var componentAnalytics = new ComponentAnalytics({
  packageName: Version.name,
  version: Version.version
});
componentAnalytics.trackPackageLoad();

// components/skeleton/react/src/index.ts
import { SkeletonAnimationType, defaultSkeletonAreaProps as defaultSkeletonAreaProps2, defaultSkeletonItemProps as defaultSkeletonItemProps2, defaultSkeletonTableProps as defaultSkeletonTableProps2, defaultSkeletonTextProps as defaultSkeletonTextProps2, getSkeletonAreaIconClasses as getSkeletonAreaIconClasses2, getSkeletonAreaRootClasses as getSkeletonAreaRootClasses2, getSkeletonItemRootClasses as getSkeletonItemRootClasses2, getSkeletonTableCellClasses as getSkeletonTableCellClasses2, getSkeletonTableGridClasses as getSkeletonTableGridClasses2, getSkeletonTableHeaderClasses as getSkeletonTableHeaderClasses2, getSkeletonTableRootClasses as getSkeletonTableRootClasses2, getSkeletonTextClasses as getSkeletonTextClasses2, getSkeletonTextRootClasses as getSkeletonTextRootClasses2, skeletonAreaStyleSheet as skeletonAreaStyleSheet2, skeletonItemStyleSheet as skeletonItemStyleSheet2, skeletonSizeVariants, skeletonTableStyleSheet as skeletonTableStyleSheet2, skeletonTextStyleSheet as skeletonTextStyleSheet2 } from "@gs-ux-uitoolkit-common/skeleton";

// components/skeleton/react/src/skeleton-text.tsx
import { useEffect } from "react";
import { useStyleSheet } from "@gs-ux-uitoolkit-react/style";
import {
  skeletonTextStyleSheet,
  getSkeletonTextRootClasses,
  getSkeletonTextClasses,
  defaultSkeletonTextProps
} from "@gs-ux-uitoolkit-common/skeleton";
import { useTheme } from "@gs-ux-uitoolkit-react/theme";
import { jsx } from "react/jsx-runtime";
var SkeletonText = (props) => {
  const _a = props, {
    typography = defaultSkeletonTextProps.typography,
    width = defaultSkeletonTextProps.width,
    lines = defaultSkeletonTextProps.lines,
    animation = defaultSkeletonTextProps.animation,
    disableAriaLabel = defaultSkeletonTextProps.disableAriaLabel,
    className,
    classes: overrideClasses,
    "aria-label": ariaLabel = defaultSkeletonTextProps["aria-label"]
  } = _a, otherProps = __objRest(_a, [
    "typography",
    "width",
    "lines",
    "animation",
    "disableAriaLabel",
    "className",
    "classes",
    "aria-label"
  ]);
  const theme = useTheme();
  const cssClasses = useStyleSheet(skeletonTextStyleSheet, __spreadProps(__spreadValues({}, props), { theme }));
  const rootCx = getSkeletonTextRootClasses({ cssClasses, className, overrideClasses });
  const textCx = getSkeletonTextClasses({ cssClasses });
  const linesMap = Array((lines || 1) + 1).join(".").split("");
  useEffect(() => {
    componentAnalytics.trackRender({
      componentName: "skeleton-text",
      officialComponentName: "other"
    });
  }, []);
  return jsx(
    "div",
    __spreadProps(__spreadValues({
      "data-gs-uitk-component": "skeleton-text",
      "data-typography": typography,
      "data-lines": lines,
      "data-animation": animation,
      className: rootCx,
      "aria-busy": "true",
      "aria-live": "off",
      "aria-label": disableAriaLabel ? void 0 : ariaLabel
    }, otherProps), {
      children: linesMap.map((s, i) => jsx(
        "div",
        {
          "data-cy": "gs-uitk-skeleton__text",
          "data-skeleton-text-line": `line-${s}${i}`,
          className: textCx,
          style: { width: props.width }
        },
        i
      ))
    })
  );
};

// components/skeleton/react/src/skeleton-table.tsx
import { useEffect as useEffect2 } from "react";
import { useStyleSheet as useStyleSheet2 } from "@gs-ux-uitoolkit-react/style";
import {
  skeletonTableStyleSheet,
  getSkeletonTableRootClasses,
  getSkeletonTableHeaderClasses,
  getSkeletonTableCellClasses,
  getSkeletonTableGridClasses,
  defaultSkeletonTableProps
} from "@gs-ux-uitoolkit-common/skeleton";
import { useTheme as useTheme2 } from "@gs-ux-uitoolkit-react/theme";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var SkeletonTable = (props) => {
  const _a = props, {
    rows = defaultSkeletonTableProps.rows,
    columns = defaultSkeletonTableProps.columns,
    width = defaultSkeletonTableProps.width,
    animation = defaultSkeletonTableProps.animation,
    className,
    classes: overrideClasses,
    "aria-label": ariaLabel = defaultSkeletonTableProps["aria-label"]
  } = _a, otherProps = __objRest(_a, [
    "rows",
    "columns",
    "width",
    "animation",
    "className",
    "classes",
    "aria-label"
  ]);
  const theme = useTheme2();
  const cssClasses = useStyleSheet2(skeletonTableStyleSheet, __spreadProps(__spreadValues({}, props), { theme }));
  const rootCx = getSkeletonTableRootClasses({ cssClasses, className, overrideClasses });
  const gridCx = getSkeletonTableGridClasses({ cssClasses });
  const headerCx = getSkeletonTableHeaderClasses({ cssClasses });
  const cellCx = getSkeletonTableCellClasses({ cssClasses });
  const rowsMap = Array(rows).fill("");
  const columnsMap = Array(columns).fill("");
  useEffect2(() => {
    componentAnalytics.trackRender({
      componentName: "skeleton-table",
      officialComponentName: "other"
    });
  }, []);
  return jsxs(
    "div",
    __spreadProps(__spreadValues({
      "data-gs-uitk-component": "skeleton-table",
      "data-rows": rows,
      "data-columns": columns,
      "data-width": width,
      "data-animation": animation,
      className: rootCx,
      "aria-busy": "true",
      "aria-live": "off",
      "aria-label": ariaLabel
    }, otherProps), {
      children: [
        jsx2("div", { className: headerCx, children: columnsMap.map((c, ci) => jsx2(
          SkeletonText,
          {
            "data-skeleton-header-cell": `cell-${c}${ci}`,
            typography: "body03",
            width: `50%`,
            animation: props.animation,
            className: cellCx,
            disableAriaLabel: true
          },
          ci
        )) }),
        rowsMap.map((r, ri) => jsx2("div", { className: gridCx, children: columnsMap.map((c, ci) => jsx2(
          SkeletonText,
          {
            "data-skeleton-table-cell": `cell-${c}${ci}${r}${ri}`,
            typography: "body03",
            width: "80%",
            animation: props.animation,
            className: cellCx,
            disableAriaLabel: true
          },
          ci
        )) }, ri))
      ]
    })
  );
};

// components/skeleton/react/src/skeleton-area.tsx
import { useEffect as useEffect3 } from "react";
import { Icon } from "@gs-ux-uitoolkit-react/icon-font";
import { useStyleSheet as useStyleSheet3 } from "@gs-ux-uitoolkit-react/style";
import {
  skeletonAreaStyleSheet,
  getSkeletonAreaRootClasses,
  getSkeletonAreaIconClasses,
  defaultSkeletonAreaProps
} from "@gs-ux-uitoolkit-common/skeleton";
import { useTheme as useTheme3 } from "@gs-ux-uitoolkit-react/theme";
import { jsx as jsx3 } from "react/jsx-runtime";
var SkeletonArea = (props) => {
  const _a = props, {
    width = defaultSkeletonAreaProps.width,
    height = defaultSkeletonAreaProps.height,
    icon,
    animation = defaultSkeletonAreaProps.animation,
    className,
    classes: overrideClasses,
    "aria-label": ariaLabel = defaultSkeletonAreaProps["aria-label"]
  } = _a, otherProps = __objRest(_a, [
    "width",
    "height",
    "icon",
    "animation",
    "className",
    "classes",
    "aria-label"
  ]);
  const theme = useTheme3();
  const cssClasses = useStyleSheet3(skeletonAreaStyleSheet, __spreadValues({ theme }, props));
  const areaCx = getSkeletonAreaRootClasses({ cssClasses, className, overrideClasses });
  const iconCx = getSkeletonAreaIconClasses({ cssClasses });
  useEffect3(() => {
    componentAnalytics.trackRender({
      componentName: "skeleton-area",
      officialComponentName: "other"
    });
  }, []);
  return jsx3(
    "div",
    __spreadProps(__spreadValues({
      "data-gs-uitk-component": "skeleton-area",
      "data-width": width,
      "data-height": height,
      "data-icon": icon,
      "data-animation": animation,
      className: areaCx,
      "aria-busy": "true",
      "aria-live": "off",
      "aria-label": ariaLabel
    }, otherProps), {
      children: icon && jsx3(Icon, { name: icon || "image", type: "outlined", className: iconCx })
    })
  );
};

// components/skeleton/react/src/skeleton-item.tsx
import { useEffect as useEffect4 } from "react";
import { useStyleSheet as useStyleSheet4 } from "@gs-ux-uitoolkit-react/style";
import { useTheme as useTheme4 } from "@gs-ux-uitoolkit-react/theme";
import {
  skeletonItemStyleSheet,
  getSkeletonItemRootClasses,
  defaultSkeletonItemProps
} from "@gs-ux-uitoolkit-common/skeleton";
import { jsx as jsx4 } from "react/jsx-runtime";
var SkeletonItem = (props) => {
  const _a = props, {
    shape = defaultSkeletonItemProps.shape,
    size = defaultSkeletonItemProps.size,
    width = defaultSkeletonItemProps.width,
    animation = defaultSkeletonItemProps.animation,
    disableAriaLabel = defaultSkeletonItemProps.disableAriaLabel,
    className,
    "aria-label": ariaLabel = defaultSkeletonItemProps["aria-label"],
    classes: overrideClasses
  } = _a, otherProps = __objRest(_a, [
    "shape",
    "size",
    "width",
    "animation",
    "disableAriaLabel",
    "className",
    "aria-label",
    "classes"
  ]);
  const theme = useTheme4();
  const cssClasses = useStyleSheet4(skeletonItemStyleSheet, __spreadValues({ theme }, props));
  const rootCx = getSkeletonItemRootClasses({ cssClasses, className, overrideClasses });
  useEffect4(() => {
    componentAnalytics.trackRender({
      componentName: "skeleton-item",
      officialComponentName: "other"
    });
  }, []);
  return jsx4(
    "div",
    __spreadValues({
      "data-gs-uitk-component": "skeleton-item",
      "data-shape": shape,
      "data-size": size,
      "data-width": width,
      "data-animation": animation,
      className: rootCx,
      "aria-label": disableAriaLabel ? void 0 : ariaLabel
    }, otherProps)
  );
};
export {
  SkeletonAnimationType,
  SkeletonArea,
  SkeletonItem,
  SkeletonTable,
  SkeletonText,
  Version,
  defaultSkeletonAreaProps2 as defaultSkeletonAreaProps,
  defaultSkeletonItemProps2 as defaultSkeletonItemProps,
  defaultSkeletonTableProps2 as defaultSkeletonTableProps,
  defaultSkeletonTextProps2 as defaultSkeletonTextProps,
  getSkeletonAreaIconClasses2 as getSkeletonAreaIconClasses,
  getSkeletonAreaRootClasses2 as getSkeletonAreaRootClasses,
  getSkeletonItemRootClasses2 as getSkeletonItemRootClasses,
  getSkeletonTableCellClasses2 as getSkeletonTableCellClasses,
  getSkeletonTableGridClasses2 as getSkeletonTableGridClasses,
  getSkeletonTableHeaderClasses2 as getSkeletonTableHeaderClasses,
  getSkeletonTableRootClasses2 as getSkeletonTableRootClasses,
  getSkeletonTextClasses2 as getSkeletonTextClasses,
  getSkeletonTextRootClasses2 as getSkeletonTextRootClasses,
  skeletonAreaStyleSheet2 as skeletonAreaStyleSheet,
  skeletonItemStyleSheet2 as skeletonItemStyleSheet,
  skeletonSizeVariants,
  skeletonTableStyleSheet2 as skeletonTableStyleSheet,
  skeletonTextStyleSheet2 as skeletonTextStyleSheet
};
//# sourceMappingURL=index.mjs.map
